import { render, staticRenderFns } from "./two-factor-settings.vue?vue&type=template&id=05469c18&scoped=true"
import script from "./two-factor-settings.vue?vue&type=script&lang=js"
export * from "./two-factor-settings.vue?vue&type=script&lang=js"
import style0 from "./two-factor-settings.vue?vue&type=style&index=0&id=05469c18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05469c18",
  null
  
)

export default component.exports